<template>
  <div class="view news">
    <section class="banner">
      <div class="banner-background">
        <svg v-if="!isMobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1900" height="1364" viewBox="0 0 1900 1364"><defs><clipPath id="eb-a"><rect width="1900" height="1364" fill="#fff"/></clipPath><linearGradient id="eb-b" x1="-0.036" y1="0.387" x2="0.223" y2="-0.035" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#ffd400"/><stop offset="1" stop-color="#8abb2a"/></linearGradient><linearGradient id="eb-c" x1="0.471" y1="1.12" x2="0.717" y2="0.129" xlink:href="#eb-b"/><filter id="eb-d" x="-996.427" y="-1678.665" width="3024.699" height="3386.665" filterUnits="userSpaceOnUse"><feOffset dy="24" input="SourceAlpha"/><feGaussianBlur stdDeviation="48" result="e"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="e"/><feComposite in="SourceGraphic"/></filter><filter id="eb-f" x="1604.653" y="329.564" width="85.847" height="85.847" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="g"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="g"/><feComposite in="SourceGraphic"/></filter><filter id="eb-h" x="1392.572" y="218.542" width="79.291" height="79.291" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="i"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="i"/><feComposite in="SourceGraphic"/></filter><filter id="eb-j" x="1382.652" y="401.5" width="100" height="100" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="k"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="k"/><feComposite in="SourceGraphic"/></filter><filter id="eb-l" x="877.5" y="687.5" width="73" height="73" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="m"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="m"/><feComposite in="SourceGraphic"/></filter><filter id="eb-n" x="815.5" y="648.5" width="91" height="91" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="o"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="o"/><feComposite in="SourceGraphic"/></filter></defs><g clip-path="url(#eb-a)"><path d="M1977.427,1116.172c1165.781,957.611,1148.792-250.375,1148.792,307.09s-711.452,947.233-1870.276,119.4S133.067,1553.6,133.067,996.131c0-453.773,533.073-700.764,1234.163-330.885,44.894,29.435-33.583,65.2-.347,90.884s53.651-7.522,125.973,2.4S1803.086,972.962,1977.427,1116.172Z" transform="translate(2429.218 840.273) rotate(158)" fill="url(#eb-b)"/><g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#eb-d)"><path d="M1735.8,68.8c801.071,1055.6,737.631,167.285,847.943,542.018s-598.555,1220.746-1468.318,577.127S0,1399.183,0,965.77,934.723-986.8,1735.8,68.8Z" transform="translate(1621.74 -890.92) rotate(118)" fill="url(#eb-c)"/></g></g><g transform="translate(0 -100)"><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#eb-f)"><circle cx="11" cy="11" r="11" transform="matrix(-0.39, -0.92, 0.92, -0.39, 1641.75, 374.91)" fill="#ffd400"/></g><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#eb-h)"><circle cx="8.5" cy="8.5" r="8.5" transform="matrix(-0.39, -0.92, 0.92, -0.39, 1427.71, 257.33)" fill="#ffd400"/></g><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#eb-j)"><circle cx="21.5" cy="21.5" r="21.5" transform="translate(1411.15 418)" fill="#ffd400"/></g><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#eb-l)"><circle cx="8" cy="8" r="8" transform="translate(906 704)" fill="#fff"/></g><g transform="matrix(1, 0, 0, 1, 0, 100)" filter="url(#eb-n)"><circle cx="17" cy="17" r="17" transform="translate(844 665)" fill="#ffd400"/></g></g></svg>
      </div>
      <div class="wrapper">
        <div class="page-title">
          <svg v-if="!isMobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="211.272" height="194" viewBox="0 0 211.272 194"><defs><filter id="ebb-a" x="13.37" y="5.318" width="197.902" height="166.604" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="b"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="b"/><feComposite in="SourceGraphic"/></filter><filter id="ebb-c" x="115.566" y="115" width="79" height="79" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="d"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="d"/><feComposite in="SourceGraphic"/></filter><filter id="ebb-e" x="116" y="0" width="68" height="68" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="f"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="f"/><feComposite in="SourceGraphic"/></filter><filter id="ebb-g" x="0" y="99" width="66" height="66" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="h"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="h"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(-293.5 -342.5)"><g transform="matrix(1, 0, 0, 1, 293.5, 342.5)" filter="url(#ebb-a)"><path d="M141.209,80.369c1.547,42.477-25.256,32.973-79.309,50.016S-11.6,74.365,7.566,38.2,139.662,37.893,141.209,80.369Z" transform="translate(41.5 -1.5)" fill="#ffd400"/></g><g transform="matrix(1, 0, 0, 1, 293.5, 342.5)" filter="url(#ebb-c)"><circle cx="11" cy="11" r="11" transform="translate(144.07 131.5)" fill="#ffd400"/></g><g transform="matrix(1, 0, 0, 1, 293.5, 342.5)" filter="url(#ebb-e)"><circle cx="5.5" cy="5.5" r="5.5" transform="translate(144.5 16.5)" fill="#ffd400"/></g><g transform="matrix(1, 0, 0, 1, 293.5, 342.5)" filter="url(#ebb-g)"><circle cx="4.5" cy="4.5" r="4.5" transform="translate(28.5 115.5)" fill="#ffd400"/></g></g></svg>
          <h1>Events</h1>
          <p v-if="page" v-html="page.headline.replace(/\n/g, '<br>')"></p>
        </div>
        <div class="next-image" v-if="nextEvent || events.length">
          <router-link :to="`/events/${(nextEvent && nextEvent.id) || (events[0] && events[0].id)}`">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1094" height="610" viewBox="0 0 1094 610"><defs><clipPath id="a"><rect width="1094" height="610" transform="translate(398 350)" fill="none"/></clipPath><pattern id="b" width="1" height="1" viewBox="0 70.999 1071.57 572.381"><image preserveAspectRatio="xMidYMid slice" width="1071.57" height="714.38" :xlink:href="(nextEvent || events[0]).image"/></pattern></defs><g transform="translate(-398 -350)" clip-path="url(#a)"><g transform="translate(-727.183 -2666.302)"><path d="M497.787,173c379.336,426.067,323.269,62.632,367.382,212.162S761.85,800.434,401.131,511.2,44.042,497.92-.071,348.389,118.451-253.063,497.787,173Z" transform="translate(1145.781 3234.833) rotate(-29)" fill="#8abb2a" opacity="0.12"/><path d="M445.747,540.806c0-14.6,17.359-29.729,41.119-29.729s57.381,15.132,57.381,29.729-12.147,31.576-35.908,31.576S445.747,555.4,445.747,540.806ZM210.677,414.852C-172.207,380.634-4.418-.072,481.987,0S798.542,174.238,989.844,250.074s18.442,279.018-226.918,312.974c-24.964,3.455-46.607,5.027-65.74,5.027C528.274,568.077,554.605,445.588,210.677,414.852ZM998.213,228.873c-23.56-1.8-60.5-21.629-67.157-38.177s8.394-32.537,37.245-32.071,52.221,11.2,63.254,26.575c10.715,14.928-8.608,43.75-31.31,43.751Q999.232,228.951,998.213,228.873Zm-86.62-75.966c-6.2-3.334-6.752-13.179.052-14.529s21,1.173,26.243,5.17,4.451,9.538-3.522,11.667a32.752,32.752,0,0,1-8.427,1.09A30.7,30.7,0,0,1,911.593,152.908Z" transform="translate(1141.183 3030.745)" fill="url(#b)"/></g></g></svg>
          </router-link>
        </div>
        <router-link v-if="nextEvent" :to="`/events/${nextEvent.id}`" class="next-event">
          <div class="event-title"><span>{{nextEvent.title}}&nbsp;<i class="fas fa-long-arrow-alt-right"></i></span></div>
          <div class="event-date"><span><span class="month"><DateFormat class="mobile" :date="nextEvent.date.toDate()" format="%Lm" /><DateFormat :date="nextEvent.date.toDate()" format="%lm" /></span>&nbsp;<DateFormat :date="nextEvent.date.toDate()" format="%d, %Y" /></span></div>
          <div class="event-location"><span>{{nextEvent.location}}</span></div>
        </router-link>
        <router-link v-else-if="events.length" :to="`/events/${events[0].id}`" class="next-event">
          <div class="event-title"><span>{{events[0].title}}&nbsp;<i class="fas fa-long-arrow-alt-right"></i></span></div>
          <div class="event-date"><span><span class="month"><DateFormat class="mobile" :date="events[0].date.toDate()" format="%Lm" /><DateFormat :date="events[0].date.toDate()" format="%lm" /></span>&nbsp;<DateFormat :date="events[0].date.toDate()" format="%d, %Y" /></span></div>
          <div class="event-location"><span>{{events[0].location}}</span></div>
        </router-link>
      </div>
    </section>
    <section class="events">
      <div class="wrapper">
        <div class="title-line">
          <h2>What's on?</h2>
          <div class="subtitle">Discover all events and workshops</div>
        </div>
        <div class="posts">
          <div class="no-events" v-if="!events.length">
            <p>Oops… <br>Come back later for the <br>latest <b>CAST Events…</b> <br>Stay Tuned!</p>
          </div>
          <EventItem :event="event" class="post" v-for="event in events" :key="event.id" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import EventItem from '../components/EventItem'
import DateFormat from '../components/DateFormat'

export default {
  name: 'events',
  components: {
    DateFormat,
    EventItem
  },
  computed: {
    ...mapGetters({
      'db': 'getDb',
      isMobile: 'getMobile'
    }),
    events() {
      if(!this.nextEvent) return this.allEvents
      return this.allEvents.filter(event => event.id !== this.nextEvent.id)
    }
  },
  data() {
    return {
      allEvents: [],
      nextEvent: null,
      page: null
    }
  },
  mounted: function() {
    this.pageRef = this.db().collection('settings').doc('events').onSnapshot(page => {
      this.page = page.data()
    })
    this.eventsRef = this.db().collection('events').orderBy('date', 'desc').onSnapshot(events => {
      this.allEvents = events.docs.map(doc => doc.data())
      if(this.allEvents.length) {
        this.preloadImages(this.allEvents.slice(0, 5).map(e => e.image))
        .then(() => {
          this.$store.commit('setPageLoading', false)
        })
        .catch(() => {
          this.$store.commit('setPageLoading', false)
        })
      }
      else {
        this.preloadImages([
          require('@/assets/cast_events_noevents@2x.png')
        ])
        .then(() => {
          this.$store.commit('setPageLoading', false)
        })
        .catch(() => {
          this.$store.commit('setPageLoading', false)
        })
      }
    })
    this.nextEventRef = this.db().collection('events').where('date', '>=', new Date()).orderBy('date').limit(1).onSnapshot(events => {
      this.nextEvent = events.size ? events.docs[0].data() : null
    })
  },
  beforeDestroy: function() {
    if(this.pageRef) this.pageRef()
    if(this.eventsRef) this.eventsRef()
    if(this.nextEventRef) this.nextEventRef()
  }
}
</script>

<style scoped>
.banner {
  position: relative;
  height: 100vh;
  /* background: url(../assets/cast_events_banner.png) no-repeat bottom center/cover; */
}

.banner .next-event .event-date .mobile {
  display: none;
}

.banner .banner-background {
  position: absolute;
  top: 0;
  width: 1920px;
  left: 50%;
  transform: translateX(-50%);
}

.banner .banner-background svg,
.banner .banner-background img {
  display: block;
  width: 100%;
  height: auto;
}

.banner .wrapper {
  padding-top: 234px;
  height: 100%;
}

.banner .next-image {
  width: 1094px;
  max-width: 100%;
  margin: 64px auto 0;
}

.banner .next-image svg {
  display: block;
  width: 100%;
  height: 60vh;
}

.banner .next-event {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 58px;
  margin: auto;
  width: 392px;
  height: 104px;
  padding: 22px 24px 0 40px;
  color: #8ABB2A;
  line-height: 1;
  text-transform: uppercase;
  z-index: 4;
}

.banner .next-event:before {
  content: '';
  position: absolute;
  width: 256px;
  height: 200px;
  top: -76px;
  left: -135px;
  background: url(../assets/cast_events_bubbles.svg) no-repeat center/contain;
  pointer-events: none;
}

.banner .next-event:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 52px;
  background: #fff;
  box-shadow: 0 12px 25px rgba(0, 52, 77, .08);
}

.banner .next-event > * {
  position: relative;
  z-index: 1;
}

.banner .next-event i {
  font-size: 1.42rem;
  padding-right: 4px;
  margin-left: 8px;
  vertical-align: baseline;
}

.banner .next-event .event-title {
  position: relative;
  font-size: 1.1rem;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 36px;
  margin-bottom: 4px;
}

.banner .next-event .event-date {
  font-size: 1.28rem;
  font-weight: bold;
  letter-spacing: .2em;
}

.banner .next-event .event-date .month {
  font-size: 1rem;
}

.banner .next-event .event-location {
  font-size: .72rem;
  letter-spacing: .58em;
  margin-top: 8px;
}

.banner .next-event > i,
.banner .next-event > div > span {
  display: inline-block;
  transition: transform .16s ease-out;
  will-change: transform;
}

@media screen and (min-width: 1025px) {
  .banner .next-event:hover > i,
  .banner .next-event:hover > div > span {
    transform: translateX(calc(321px - 100%));
  }
}

.page-title {
  position: relative;
  display: flex;
  align-items: center;
  color: #fff;
  padding-left: 202px;
}

.page-title > svg {
  position: absolute;
  top: -40px;
  left: 90px;

}

.page-title h1 {
  position: relative;
  font: bold 3.21em/1 'Butler';
}

.page-title p {
  position: relative;
  margin-left: 196px;
  width: 358px;
}

.page-title p:before {
  content: '';
  position: absolute;
  display: block;
  top: 0;
  left: -136px;
  bottom: 0;
  width: 60px;
  height: 1px;
  margin: auto;
  background: #FFD400;
}

section h2 {
  font: bold 3.21em/1 'Butler';
}

section h2:after {
  content: '';
  display: block;
  width: 74px;
  height: 1px;
  background: currentColor;
  margin-top: 20px;
}

.events {
  margin-top: 20px;
}

.title-line {
  display: flex;
  align-items: center;
  margin-left: 182px;
}

.title-line h2 {
  color: #8ABB2A;
}

.title-line h2:after {
  display: inline-block;
  vertical-align: middle;
  margin: 0 36px;
}

.title-line .subtitle {
  font-size: .72em;
  letter-spacing: .58em;
  color: #8ABB2A;
  text-transform: uppercase;
}

.posts {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 64px;
}

.posts .no-events {
  width: 1000px;
  height: 550px;
  background: url(../assets/cast_events_noevents@2x.png) no-repeat center/contain;
  margin: auto;
  color: #fff;
  padding-top: 200px;
  padding-right: 23%;
  text-align: right;
  font-size: 2.29em;
  line-height: 1.0625;
  margin-top: -20px;
}

.posts .post {
  width: 33.333333%;
  text-align: center;
  margin-top: 80px;
}

@media screen and (max-width: 1024px) {
  .banner .next-event {
    width: 268px;
    height: 74px;
    padding: 14px 28px;
    margin: auto;
    left: 96px;
    right: 0;
    bottom: 17vh;
    padding-right: 48px;
  }
  .banner .next-event > i {
    position: absolute;
    right: 16px;
    top: 28px;
  }
  .banner .next-event .event-date .month .date-format {
    display: none;
  }
  .banner .next-event > div > span {
    font-size: 8px;
  }
  .banner .next-event .event-date {
    font-size: 11px;
  }
  .banner .next-event .event-date .month .mobile {
    display: block;
    font-size: 11px;
  }
  .banner .next-event > div > span > .date-format {
    margin-left: -4px;
    font-size: 14px;
  }
  .page-title {
    color: #343434;
  }
  .page-title,
  .title-line {
    display: block;
    padding: 0;
    text-align: center;
    margin: 0;
  }
  .page-title h1 {
    color: #8ABB2A;
    height: 32px;
  }
  .title-line h2 {
    font-size: 28px;
  }
  .page-title p,
  .title-line .subtitle {
    width: 420px;
    max-width: 100%;
    margin: auto;
  }
  .page-title p:before,
  .title-line h2:after {
    position: relative;
    display: block;
    left: auto;
    margin: 16px auto 24px;
    background: #8ABB2A;
  }
  .banner {
    height: auto;
  }
  .banner .wrapper {
    padding-bottom: 24px;
  }
  .banner .next-image svg {
    height: auto;
  }
  .banner .next-event {
    bottom: 0;
  }
  .events {
    margin-top: 72px;
  }
  .posts .post {
    margin-top: 48px;
  }
}

@media screen and (max-width: 760px) {
  .posts .post {
    width: 50%;
  }
}

@media screen and (max-width: 680px) {
  .banner .wrapper {
    padding-top: 172px;
  }
}

@media screen and (max-width: 650px) {
  .posts .no-events {
    font-size: 21px;
    padding-top: 107px;
    height: 300px;
    margin-top: 32px;
    padding-right: 18%;
  }
}

@media screen and (max-width: 480px) {
  .posts .post {
    width: 100%;
  }
  .banner .next-event {
    left: 24px;
  }
}
</style>

